import { setUserConfig } from "app/user-setup/store/userSetup.slice";
import { authInstance } from "./base";
import { PublicClientApplication } from "@azure/msal-browser";
import { loginRequest, msalConfig } from "./useAuth";
import getEnv from "env";

const msalInstance = new PublicClientApplication(msalConfig);

const REACT_APP_VIATRACKING_API_KEY = getEnv("REACT_APP_VIATRACKING_API_KEY");

export const getAccessToken = async (
  tokenApi,
  setIsAuthenticated,
  dispatch
) => {
  try {
    const { data } = await authInstance.get(`/auth`, {
      headers: {
        apiKey: REACT_APP_VIATRACKING_API_KEY,
        token: tokenApi,
      },
    });
    dispatch(setUserConfig(data));
    sessionStorage.setItem("msToken", tokenApi);
    sessionStorage.setItem("AccessToken", data.access_token);
    sessionStorage.setItem("SessionID", data.sessionId);
    setIsAuthenticated(true);
  } catch (err: any) {
    console.log("Não foi possível recuperar o token", err);
    await msalInstance.logoutRedirect(loginRequest);
  }
};
